module.exports = __webpack_public_path__ + "static/media/sub-card-label-8-over.0717c440.svg";